// lib/auth/handleSessionEnd.ts

import { QueryClient } from "@tanstack/react-query";
import { useRouter } from "next/navigation";

export type AppRouterInstance = ReturnType<typeof useRouter>;

export const handleSessionEnd = (
  queryClient: QueryClient,
  router: AppRouterInstance,
) => {
  // AuthListener의 SIGNED_OUT 이벤트에서 리다이렉트를 처리하므로
  // 여기서는 queryClient만 정리
  setTimeout(() => {
    queryClient.clear();
  }, 100);
};
